import { IIconProps } from './icon';

export const IconWorld = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconWorld${cy}`}
    >
      <path
        d="M5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0ZM1 5C1 4.695 1.04 4.395 1.105 4.11L3.495 6.5V7C3.495 7.55 3.945 8 4.495 8V8.965C2.53 8.715 1 7.035 1 5ZM7.945 7.7C7.815 7.295 7.445 7 6.995 7H6.495V5.5C6.495 5.225 6.27 5 5.995 5H2.995V4H3.995C4.27 4 4.495 3.775 4.495 3.5V2.5H5.495C6.045 2.5 6.495 2.05 6.495 1.5V1.295C7.96 1.885 9 3.325 9 5C9 6.04 8.595 6.99 7.945 7.7Z"
        fill="#A2A4A4"
      />
    </svg>
  );
};
